import { render, staticRenderFns } from "./HomeEight.vue?vue&type=template&id=08f1577e"
import script from "./HomeEight.vue?vue&type=script&lang=js"
export * from "./HomeEight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports